module.exports = __webpack_public_path__ + "img/product_service.995ae37e.png";